import React from "react"
import {Pane} from "evergreen-ui";
import TemporaryTurnPage from "../../Constructor/temporaryTurnConstructor/TemporaryTurnPage";
import PeriodsValuesPage from "../../Constructor/decadeConstructor/PeriodsValuesPage";
import RainFloodPage from "../../Constructor/rainFlood/RainFloodPage";
import RiverFloodPage from "../../Constructor/riverFlood/RiverFloodPage";
import EvaporationPage from "../../Constructor/evaporation/EvaporationPage";


export default function FullTemplateInfoDialog({constructorType}) {

    return (
        <Pane>
            {
                constructorType == 'DECADE'? <PeriodsValuesPage isFullInfo={true}/> :
                constructorType == 'TT' ? <TemporaryTurnPage isFullInfo={true}/> :
                constructorType == 'RAIN_FLOOD'? <RainFloodPage isFullInfo={true} /> :
                constructorType == 'RIVER_FLOOD' ? <RiverFloodPage isFullInfo={true}/> :
                constructorType == 'EVAPORATION' ? <EvaporationPage isFullInfo={true}/> : <></>
            }
        </Pane>
    )
}